/**
 * PC/Console Top Charts 筛选器 hover 文案配置。
 *
 * 文案定义见 _locales 下 infoDoc.ts 的 dbi_info_pcconsole_filter_*_hover 系列 key。
 * 由 usePcConsoleFilters 统一注入 specialParams.filterTips，MetricsTable / DataBrain 校准 Tab 共用。
 * 仅用于 /topCharts/pcConsoleGames/* 榜单页，勿在其他模块复用。
 */
import * as filterKeyMap from '@intelligence/components/Filter/FilterBase/_config';
import {
  buildFilterTips,
  type TTopChartsFilterTipsFormatMessage,
} from '@intelligence/pages/TopCharts/_config/topChartsFilterTipsUtils';

/** 筛选项：filter key → locale id */
const BASE_LOCALE_KEY_MAP: Record<string, string> = {
  // 常用筛选
  [filterKeyMap.MY_FILTER]: 'dbi_info_pcconsole_filter_my_filter_hover',
  [filterKeyMap.RANGE_TIME]: 'dbi_info_pcconsole_filter_range_time_hover',
  [filterKeyMap.REGION]: 'dbi_info_pcconsole_filter_region_hover',
  [filterKeyMap.PLATFORMCASCADER]: 'dbi_info_pcconsole_filter_platform_hover',
  [filterKeyMap.GENRETOR]: 'dbi_info_pcconsole_filter_genre_hover',
  [filterKeyMap.ALL_Games]: 'dbi_info_pcconsole_filter_all_games_hover',
  // 公司 / 研发
  [filterKeyMap.PUBLISHER_COMPANY]: 'dbi_info_pcconsole_filter_company_hover',
  [filterKeyMap.PUBLISHER_CLASS]: 'dbi_info_pcconsole_filter_publisher_class_hover',
  [filterKeyMap.PUBLISHER_REGION]: 'dbi_info_pcconsole_filter_publisher_region_hover',
  [filterKeyMap.DEVELOPER]: 'dbi_info_pcconsole_filter_developer_hover',
  // MScience
  [filterKeyMap.DIGITAL_RANGE]: 'dbi_info_pcconsole_filter_digital_range_hover',
  // Steam
  [filterKeyMap.PCU_RANGE]: 'dbi_info_pcconsole_filter_pcu_range_hover',
  [filterKeyMap.PREMIUM_RANGE]: 'dbi_info_pcconsole_filter_premium_range_hover',
  [filterKeyMap.STEAM_TAGS]: 'dbi_info_pcconsole_filter_steam_tag_hover',
  [filterKeyMap.GAME_MODE]: 'dbi_info_pcconsole_filter_game_mode_hover',
  [filterKeyMap.PRICE_RANGE]: 'dbi_info_pcconsole_filter_price_range_hover',
  [filterKeyMap.WISHLISTS_RANGE]: 'dbi_info_pcconsole_filter_wishlists_range_hover',
  // GSD：筛选项 key 为 publisher，对应 GSD 分段筛选组
  [filterKeyMap.PUBLISHER]: 'dbi_info_pcconsole_filter_gsd_segment_hover',
  // NPD
  [filterKeyMap.PHYSICAL_RANGE]: 'dbi_info_pcconsole_filter_physical_range_hover',
  // IGDB
  [filterKeyMap.GAME_ENGINE]: 'dbi_info_pcconsole_filter_game_engine_hover',
};

/**
 * 生成 PC/Console Top Charts 各筛选项 hover 文案。
 * @returns filterKey → 已翻译文案，供 specialParams.filterTips 使用
 */
export const getPcConsoleTopChartsFilterTips = (
  formatMessage: TTopChartsFilterTipsFormatMessage,
): Record<string, string> => buildFilterTips(formatMessage, BASE_LOCALE_KEY_MAP);
